import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import WhatsNewDetailContainer from '../../containers/WhatsNewDetail';
import i18n from '../../resources/i18n';
/**
 * What's New一覧画面
 * @param props
 */
const WhatsNewDetail: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('WhatsNewDetail_0008')} />
			<WhatsNewDetailContainer {...props} />
		</>
	);
};

export default WhatsNewDetail;



// WEBPACK FOOTER //
// ./src/pages/personal/WhatsNewDetail.tsx